import PropTypes from 'prop-types';
import React from 'react';
import { FormGroup, Label } from 'reactstrap';
//import './FormFileUpload.scss';
import FileUpload from './FileUpload';

const FormFileUpload = ({
  label,
  onFileUploaded,
  initialFileUrl,
  hideUploadAfterFile,
  acceptedFileTypes,
  className,
  formGroupClassName,
  children,
  isClearable,
  uploadDescription,
  check = false,
  isPublic = false,
}) => (
  <FormGroup check={check} className={formGroupClassName}>
    {label && <Label className="form-label">{label}</Label>}
    <div
      className={`input-group ${
        children ? 'file-upload-wrapper' : 'empty-file-upload-wrapper'
      }`}
    >
      <FileUpload
        onFileUploaded={(fileInfo) => onFileUploaded(fileInfo)}
        initialFileUrl={initialFileUrl}
        hideUploadAfterFile={hideUploadAfterFile}
        acceptedFileTypes={acceptedFileTypes}
        className={className}
        isClearable={isClearable}
        uploadDescription={uploadDescription}
        isPublic={isPublic}  
      >
        {children}
      </FileUpload>
    </div>
  </FormGroup>
);

FormFileUpload.propTypes = {
  label: PropTypes.string,
  onFileUploaded: PropTypes.func.isRequired,
  initialFileUrl: PropTypes.string,
  hideUploadAfterFile: PropTypes.bool,
  acceptedFileTypes: PropTypes.string,
  className: PropTypes.string,
  formGroupClassName: PropTypes.string,
  children: PropTypes.node,
  isClearable: PropTypes.bool,
};

export { FormFileUpload };
